import { Form, Formik, FormikValues } from 'formik';
import React, { useEffect, useRef } from 'react';
import * as Yup from 'yup';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import FormikButton from '../../../common/formik/FormikButton';
import FormikGrid from '../../../common/formik/FormikGrid';
import FormikTextField from '../../../common/formik/FormikTextField';
import { Product } from '../Product.interface';
import { useCreateProduct } from '../Product.hooks';

export interface ProductCreateDialogProps {
  open: boolean;
  onCancel?: () => void;
  onCreated?: (supplier: Product) => void;
}

const ProductCreateDialog: React.FC<ProductCreateDialogProps> = ({
  open,
  onCancel,
  onCreated
}) => {
  const formikRef = useRef<FormikValues>();
  const {
    createdProduct,
    isCreating,
    createError,
    createProduct
  } = useCreateProduct();

  useEffect(() => {
    if (!isCreating) {
      if (onCreated && createdProduct) {
        onCreated(createdProduct);
      }
      if (formikRef && formikRef.current) {
        formikRef.current.setSubmitting(false);
      }
    }
  }, [createdProduct, isCreating, onCreated]);

  return (
    <Dialog maxWidth='xs' open={open} onClose={onCancel}>
      <Formik
        innerRef={(formik: any) => (formikRef.current = formik)}
        initialValues={{
          companyName: ''
        }}
        validationSchema={Yup.object({
          name: Yup.string().required('Required')
        })}
        onSubmit={(form: any) => createProduct(form)}
      >
        <Form autoComplete='off'>
          <DialogTitle>Create Product</DialogTitle>
          <DialogContent>
            <FormikGrid>
              <FormikTextField
                autoFocus
                type='text'
                name='name'
                label='Product Name'
              />
            </FormikGrid>
            {createError && (
              <Alert severity='error'>{`Error occurred. ${createError.message}`}</Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <FormikButton>Create</FormikButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default ProductCreateDialog;
